/* eslint-disable */
import { css } from 'lit';

export default css`
	/* stylelint-disable */
  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;
